export * from './avatar';

//# sourceMappingURL=index.js.map